// extracted by mini-css-extract-plugin
export default {"page":"MatchesPage_page__ced2N"};